var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-full justify-center items-center text-blue py-8 lg:py-16"},[_c('div',{staticClass:"spinner"})])}]

export { render, staticRenderFns }